import { Outlet, useNavigate } from "react-router-dom"
import { MemberBackground, PageLoadingScreen } from "../../components/Background"
import { MemberNavbar } from "../../components/NavBar"
import { AnnouncementsComponent } from "../../components/AnnouncementsComponents"
import { requestAnnouncements } from "../../requests/setup_requests"
import { useContext, useEffect } from "react"
import { AccountContext } from "../../contexts/AccountContexts"
import { MemberFooter } from "../../components/FooterComponents"



export const MemberNavigator = () => {
    const { user } = useContext(AccountContext)
    const navigator = useNavigate()

    useEffect(() => {
        if (window.location.pathname === "/member" || window.location.pathname === "/member/") {
            navigator("/member/home")
        }
    }, [])

    useEffect(() => {
        if (user) {
            if (user.class === "dev") {
                navigator("/")
            }
            else if (user.type === "temp" ) {
                navigator("/")
            }

        }
        else {
            navigator("/")
        }
    }, [user])

    return <>
        <MemberBackground />
        <PageLoadingScreen />
        <div className="flex justify-center w-full min-h-screen">

            <div className="flex flex-col w-full max-w-[1280px] bg-gray-100 dark:bg-gray-800 min-h-full px-1">
                <MemberNavbar />
                <div className="flex flex-col items-center gap-5  py-10 px-[2px]">
                    <AnnouncementsComponent fetchCall={requestAnnouncements} />
                </div>
                <Outlet />
                <MemberFooter />
            </div>
        </div>
    </>
}